var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "screen-container" }, [
    _c("div", { staticClass: "screen-header" }, [
      _c("div", { staticClass: "left" }, [
        _vm._v(" Sorting Station : "),
        _c("div", { staticClass: "yelloText" }, [
          _vm._v(" " + _vm._s(_vm.SortingStation) + " "),
        ]),
      ]),
      _vm.waveStatus == "completed"
        ? _c("div", { staticClass: "center" }, [_vm._v("Complete")])
        : _vm._e(),
      _c("div", { staticClass: "right" }, [
        _vm._v(" Wave : "),
        _c("div", { staticClass: "redText" }, [
          _vm._v(" " + _vm._s(_vm.waveId) + " "),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "screen-body" }, [
      _c("div", { staticClass: "body-box" }, [
        _c("div", { staticClass: "body-left" }, [
          _c(
            "div",
            { staticClass: "body-left-select" },
            _vm._l(_vm.leftListData, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: _vm.currentIndex == index ? "numTips num" : "num",
                  on: {
                    mouseenter: function ($event) {
                      return _vm.goToSlide(index)
                    },
                    mouseleave: function ($event) {
                      _vm.isPlay = true
                      _vm.startAutoPlay()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(index + 1) + " ")]
              )
            }),
            0
          ),
          _vm._m(0),
          _c("div", { staticClass: "body-left-list" }, [
            _c(
              "div",
              { staticClass: "left-box" },
              _vm._l(_vm.leftDataShowList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class:
                      item.isGreen && index < 19
                        ? "product greenTips"
                        : item.isRed && index < 19
                        ? "product redTips"
                        : !item.isGreen && !item.isRed && index < 19
                        ? "product"
                        : item.isGreen && index == 19
                        ? "product_bot greenTips"
                        : item.isRed && index == 19
                        ? "product_bot redTips"
                        : "product_bot",
                  },
                  [
                    _c("div", [_vm._v(_vm._s(item.outerOrderNo))]),
                    _c("div", [_vm._v(_vm._s(item.basketNo))]),
                    _c("div", [
                      _vm._v(_vm._s(item.sortQty + "/" + item.totalItemQty)),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "body-center" }, [
          _c("div", { ref: "pdfTemple", staticClass: "centerNum" }, [
            _vm._v(_vm._s(_vm.centerNumber)),
          ]),
          _vm.tipsNumber
            ? _c("div", { staticClass: "tips" }, [
                _vm._v("+" + _vm._s(_vm.tipsNumber)),
              ])
            : _vm._e(),
          _c("div", { staticClass: "centerCode" }, [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.SKUCode)),
            ]),
            _vm.SKUCode
              ? _c("div", [
                  _vm._v(
                    _vm._s(_vm.pickQty) + " / " + _vm._s(_vm.totalItemQty)
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "body-right" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "right-box" },
            _vm._l(_vm.pickHistoryList, function (item, index) {
              return _c(
                "div",
                { key: index, class: index < 19 ? "product" : "product_bot" },
                [
                  _c("div", [_vm._v(_vm._s(item.rowNum))]),
                  _c("div", [_vm._v(_vm._s(item.skuCode))]),
                  _c("div", [_vm._v(_vm._s(item.basketId))]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body-left-title" }, [
      _c("div", { staticStyle: { width: "55%", "padding-left": "10%" } }, [
        _vm._v("Order ID"),
      ]),
      _c("div", { staticStyle: { width: "25%" } }, [_vm._v("Basket ID")]),
      _c("div", { staticStyle: { width: "20%" } }, [_vm._v("Progress")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body-right-title" }, [
      _c("div", { staticStyle: { width: "20%", "padding-left": "10%" } }, [
        _vm._v("No. "),
      ]),
      _c("div", { staticStyle: { width: "50%", "text-align": "center" } }, [
        _vm._v("SKU"),
      ]),
      _c("div", { staticStyle: { width: "30%" } }, [_vm._v("Basket ID")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }